'use client'

import React from 'react'
import { cn } from '@/utilities/ui'

interface PlayButtonProps {
  onClick: () => void
  className?: string
  /** The glyph has its own hardcoded sizes, so resizing the button needs this too. */
  iconClassName?: string
  label?: string
  onPointerEnter?: () => void
  onFocus?: () => void
  'aria-haspopup'?: 'dialog'
}

export const PlayButton = React.forwardRef<HTMLButtonElement, PlayButtonProps>(function PlayButton(
  {
    onClick,
    className,
    iconClassName,
    label = 'Play video',
    onPointerEnter,
    onFocus,
    'aria-haspopup': ariaHasPopup,
  },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      onPointerEnter={onPointerEnter}
      onFocus={onFocus}
      aria-label={label}
      aria-haspopup={ariaHasPopup}
      className={cn(
        // Base styles: lime green circle with centered play icon
        'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
        'bg-civo-lime rounded-full',
        'flex items-center justify-center',
        'transition-transform duration-300 hover:scale-110 motion-reduce:transition-none motion-reduce:hover:scale-100',
        'cursor-pointer z-10',
        // Responsive sizing: 48px mobile, 96px desktop
        'size-12 md:size-24',
        // Keyboard focus styling
        'focus:outline-none focus-visible:ring-4 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black',
        className,
      )}
    >
      {/* Play arrow SVG - scaled proportionally */}
      <svg
        className={cn('w-3.5 h-[15px] md:w-[26px] md:h-7 ml-0.5 lg:ml-1', iconClassName)}
        viewBox="0 0 26 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M0.0141016 0.81548C1.69785 9.51933 1.6976 18.4808 0.013582 27.1844C-0.0954021 27.7478 0.472569 28.1899 0.962735 27.9174L26 14L0.963263 0.0828121C0.473097 -0.189978 -0.0948824 0.251787 0.0141016 0.81548Z"
          fill="black"
        />
      </svg>
    </button>
  )
})
